/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Agents_Art_2_DetailInputs */

const en_services_svc_agents_art_2_detail = /** @type {(inputs: Services_Svc_Agents_Art_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts from the research`)
};

const lv_services_svc_agents_art_2_detail = /** @type {(inputs: Services_Svc_Agents_Art_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raksta, balstoties uz izpēti`)
};

/**
* | output |
* | --- |
* | "Drafts from the research" |
*
* @param {Services_Svc_Agents_Art_2_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_agents_art_2_detail = /** @type {((inputs?: Services_Svc_Agents_Art_2_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Agents_Art_2_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_agents_art_2_detail(inputs)
	return en_services_svc_agents_art_2_detail(inputs)
});